import { BillableItem } from './../../core/model/billable-item';
import { Dictionary } from 'src/app/core/model/dictionary';

export class BillableEdit
{
    public id = null;
    public version = null;
    public name = '';
    public description = '';
    public enabled = true;
    public manualAmount = false;
    public informationalOnly = false;
    public billableItems: BillableItem[] = [];
    public feeSchedule: Dictionary;
    public feeCategory: Dictionary;
    public accumulator: any;
    public externalCode = '';
}
